import { render, staticRenderFns } from "./authorityManagement.vue?vue&type=template&id=752b73d6&scoped=true&"
import script from "./authorityManagement.vue?vue&type=script&lang=js&"
export * from "./authorityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b73d6",
  null
  
)

export default component.exports